<template>
  <div class="rule-text-box" v-loading.fullscreen="isLoading">
    <div v-if="remoteContent" v-html="remoteContent"></div>
    <template v-else-if="lang === 'en-US'">
      <h2 align="center">Checklist of Shared Personal Information</h2>
      <p>
        <strong>I.</strong>&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>Checklist of Third-Party SDKs</strong>
      </p>
      <p>
        We will access software development kits (SDKs) provided by third
        parties for the realization of CIFTIS-related purposes and the safe and
        stable operation of the application.
      </p>
      <p>
        We will carry out strict security checks on third-party SDKs and require
        partners to take strict measures to protect your personal data. In order
        to meet new service requirements and in the case of changes to business
        purpose, we may adjust the third-party SDKs we access, and disclose the
        latest situation of accessing the third-party SDKs to you herein in a
        timely manner. Please note that there may be some changes in the data
        type due to the version upgrade and policy adjustment of the third-party
        SDKs. The URLs of the official website or related privacy policies are
        attached below for your reference. For details, please refer to relevant
        official announcement.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>Checklist of Android Third-Party SDKs</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Product/Type</strong>:&nbsp;&nbsp;&nbsp; WeChat
      </p>
      <p class="ql-line">Application Purpose: For sharing on WeChat</p>
      <p class="ql-line">
        Application Scenario:&nbsp; Sharing by posters and live streaming
      </p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; Information related to
        infrastructure and app
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDKs</p>
      <p class="ql-line">
        Name of Third-Party Company: Shenzhen Tencent Computer Systems Company
        Limited
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
          target="_blank"
          data-mce-href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
          >https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; EagleEye</strong><strong></strong>
      </p>
      <p class="ql-line">
        Application Purpose: Crash monitoring and crash module location
      </p>
      <p class="ql-line">
        Application Scenario:&nbsp; Crash monitoring and location during the use
        of app
      </p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">
        Name of Third-Party Company: Technical Center of JD Mall
      </p>
      <p class="ql-line">
        Privacy Policy:
        <a
          href="http://docs.avatar.jd.com/crash/sdk/android/version.html?h=%E9%9A%90%E7%A7%81"
          target="_blank"
          data-mce-href="http://docs.avatar.jd.com/crash/sdk/android/version.html?h=%E9%9A%90%E7%A7%81"
          >http://docs.avatar.jd.com/crash/sdk/android/version.html?h=%E9%9A%90%E7%A7%81</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; photoview</strong>
      </p>
      <p class="ql-line">Application Purpose: Zooming and dragging of image</p>
      <p class="ql-line">
        Application Scenario:&nbsp; Uploading pictures during live streaming of
        exhibitors
      </p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Google Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">Product/Type:&nbsp;&nbsp; Reactive Streams</p>
      <p class="ql-line">
        Application Purpose: Asynchronous data processing tool
      </p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">
        Name of Third-Party Company:
        <a
          href="http://www.reactive-streams.org/"
          target="_blank"
          data-mce-href="http://www.reactive-streams.org/"
          >r</a
        ><a
          href="http://eactive-streams.org"
          data-mce-href="http://eactive-streams.org"
          >eactive-streams.org</a
        >
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="http://www.reactive-streams.org/"
          target="_blank"
          data-mce-href="http://www.reactive-streams.org/"
          >http://www.reactive-streams.org/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product</strong>/Type:&nbsp;&nbsp;&nbsp; rxpermissions
      </p>
      <p class="ql-line">
        Application Purpose: Runtime permission application tool
      </p>
      <p class="ql-line">
        Application Scenario:&nbsp; Enabling device permissions
      </p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">
        Name of Third-Party Company: Individual (Thomas Bruyelle)
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://github.com/tbruyelle/RxPermissions#license"
          target="_blank"
          data-mce-href="https://github.com/tbruyelle/RxPermissions#license"
          >https://github.com/tbruyelle/RxPermissions#license</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; eventbus</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Application Purpose: &nbsp;&nbsp;&nbsp;&nbsp; Event registration and
          subscription tool</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Application Scenario:&nbsp;&nbsp;&nbsp;&nbsp; Internal messaging of
          app</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Name of Shared Information: NA</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Sharing Method: NA</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Name of Third-Party Company:&nbsp;&nbsp; Individual (Markus
          Junginger)</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://greenrobot.org/"
          target="_blank"
          data-mce-href="https://greenrobot.org/"
          >https://greenrobot.org/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; player</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Application Purpose: &nbsp;&nbsp;&nbsp;&nbsp; Video player
          tool</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Application Scenario:&nbsp;&nbsp;&nbsp;&nbsp; Live streaming</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Name of Shared Information: NA</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Sharing Method: NA</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Name of Third-Party Company:&nbsp;&nbsp; Shanghai Kuanyu Digital
          Technology Co., Ltd. (bilibili)</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.bilibili.com/blackboard/privacy-pc.html"
          target="_blank"
          data-mce-href="https://www.bilibili.com/blackboard/privacy-pc.html"
          >https://www.bilibili.com/blackboard/privacy-pc.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">Product/Type:&nbsp;&nbsp;&nbsp;&nbsp; subscaleview</p>
      <p class="ql-line">
        <strong
          >Application Purpose: &nbsp;&nbsp;&nbsp;&nbsp; Image zoom tool</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Application Scenario:&nbsp;&nbsp;&nbsp;&nbsp; Uploading pictures
          during live streaming</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Name of Shared Information: NA</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Sharing Method: NA</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong
          >Name of Third-Party Company:&nbsp;&nbsp; Individual
          (davemorrissey)</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://github.com/davemorrissey/subsampling-scale-image-view"
          target="_blank"
          data-mce-href="https://github.com/davemorrissey/subsampling-scale-image-view"
          >https://github.com/davemorrissey/subsampling-scale-image-view</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        Product/Type:&nbsp;&nbsp;&nbsp;&nbsp; pageindicatorview
      </p>
      <p class="ql-line">Application Purpose: Page turning indicator</p>
      <p class="ql-line">Application Scenario:&nbsp; Page turning</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">
        Name of Third-Party Company: Individual (Raman Danylyk)
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://github.com/romandanylyk/PageIndicatorView"
          target="_blank"
          data-mce-href="https://github.com/romandanylyk/PageIndicatorView"
          >https://github.com/romandanylyk/PageIndicatorView</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; </strong>Tencent Browsing Service
        (TBS)
      </p>
      <p class="ql-line">Application Purpose: Framework</p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; WIFI information, MAC address,
        IMSI, bssid, IMEI, device serial number, android_id
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDK</p>
      <p class="ql-line">
        Name of Third-Party Company: Shenzhen Tencent Computer Systems Company
        Limited
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://x5.tencent.com/tbs/policy.html"
          target="_blank"
          data-mce-href="https://x5.tencent.com/tbs/policy.html"
          >https://x5.tencent.com/tbs/policy.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; </strong>SmartRefreshLayout
      </p>
      <p class="ql-line">Application Purpose: Pull-to-refresh module</p>
      <p class="ql-line">Application Scenario:&nbsp; Pull-to-refresh</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Individual (kimonic)</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://github.com/kimonic/SmartRefreshLayout-master/blob/master/README_CN.md"
          target="_blank"
          data-mce-href="https://github.com/kimonic/SmartRefreshLayout-master/blob/master/README_CN.md"
          >https://github.com/kimonic/SmartRefreshLayout-master/blob/master/README_CN.md</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>gson</p>
      <p class="ql-line">Application Purpose: JSON parsing tool</p>
      <p class="ql-line">Application Scenario:&nbsp; GSON parsing</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Google Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>fastjson</p>
      <p class="ql-line">Application Purpose: JSON parsing tool</p>
      <p class="ql-line">Application Scenario:&nbsp; JSON parsing</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Alibaba Group</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.alibabagroup.com/cn/global/privacy"
          target="_blank"
          data-mce-href="https://www.alibabagroup.com/cn/global/privacy"
          >https://www.alibabagroup.com/cn/global/privacy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>ARouter</p>
      <p class="ql-line">Application Purpose: Route redirector</p>
      <p class="ql-line">Application Scenario:&nbsp; Route redirecting</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Alibaba Group</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.alibabagroup.com/cn/global/privacy"
          target="_blank"
          data-mce-href="https://www.alibabagroup.com/cn/global/privacy"
          >https://www.alibabagroup.com/cn/global/privacy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>glide</p>
      <p class="ql-line">Application Purpose: Image loading tool</p>
      <p class="ql-line">Application Scenario:&nbsp; Loading image</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Individual (Sam Judd)</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://github.com/bumptech/glide"
          target="_blank"
          data-mce-href="https://github.com/bumptech/glide"
          >https://github.com/bumptech/glide</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>Meizu</p>
      <p class="ql-line">
        Application Purpose: Data analysis, cloud platform and push
      </p>
      <p class="ql-line">Application Scenario:&nbsp; Push</p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; Anonymous User ID (OAID)
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDK</p>
      <p class="ql-line">
        Name of Third-Party Company: Meizu Technology Co., Ltd.
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.meizu.com/en/legal.html"
          target="_blank"
          data-mce-href="https://www.meizu.com/en/legal.html"
          >https://www.meizu.com/en/legal.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>MiPush</p>
      <p class="ql-line">Application Purpose: MIUI push service</p>
      <p class="ql-line">Application Scenario:&nbsp; Push</p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; IMEI number, device model,
        mobile operating system
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDK</p>
      <p class="ql-line">
        Name of Third-Party Company: MI Technology Co., Ltd.
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://dev.mi.com/console/doc/detail?pId=1339"
          target="_blank"
          data-mce-href="https://dev.mi.com/console/doc/detail?pId=1339"
          >https://dev.mi.com/console/doc/detail?pId=1339</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>OPPO</p>
      <p class="ql-line">Application Purpose: Push</p>
      <p class="ql-line">Application Scenario:&nbsp; Push</p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; IMEI, Serial Number, IMSI, User
        ID, Android ID, Google Advertising ID, device model, mobile battery,
        mobile operating system, lock screen status, notification bar status and
        network information
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDK</p>
      <p class="ql-line">Name of Third-Party Company: OPPO</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://open.oppomobile.com/wiki/doc#id=10288"
          target="_blank"
          data-mce-href="https://open.oppomobile.com/wiki/doc#id=10288"
          >https://open.oppomobile.com/wiki/doc#id=10288</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>okio</p>
      <p class="ql-line">Application Purpose: Network access tool</p>
      <p class="ql-line">Application Scenario:&nbsp; Network access</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Square, Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://squareup.com/us/en/legal/general/privacy"
          target="_blank"
          data-mce-href="https://squareup.com/us/en/legal/general/privacy"
          >https://squareup.com/us/en/legal/general/privacy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>zxing</p>
      <p class="ql-line">Application Purpose: Network access tool</p>
      <p class="ql-line">Application Scenario:&nbsp; Network access</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Google, Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>pinyin4j</p>
      <p class="ql-line">Application Purpose: Chinese-to-Pinyin converter</p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Google Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; </strong>Speech recognition
      </p>
      <p class="ql-line">
        Application Purpose: Speech recognition, speech synthesis,
        speech-to-text conversion
      </p>
      <p class="ql-line">
        Application Scenario:&nbsp; Negotiation, live streaming
      </p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; Webcam (camera), photo album
        (picture library), microphone (voice)
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDKs</p>
      <p class="ql-line">
        Personal Information Fields Collected: &nbsp; Webcam (camera), photo
        album (picture library), microphone (voice)
      </p>
      <p class="ql-line">Name of Third-Party Company: IFLYTEK Co., Ltd.</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.xfyun.cn/doc/policy/privacy.html"
          target="_blank"
          data-mce-href="https://www.xfyun.cn/doc/policy/privacy.html"
          >https://www.xfyun.cn/doc/policy/privacy.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; </strong>butterknife
      </p>
      <p class="ql-line">Application Purpose: Framework</p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">
        Name of Third-Party Company: Individual (Jack Wharton)
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://jakewharton.github.io/butterknife/"
          target="_blank"
          data-mce-href="https://jakewharton.github.io/butterknife/"
          >https://jakewharton.github.io/butterknife/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>webrtc</p>
      <p class="ql-line">Application Purpose: Framework</p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Google Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>mmkv</p>
      <p class="ql-line">Application Purpose: Storage framework</p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">
        Name of Third-Party Company: Shenzhen Tencent Computer Systems Company
        Limited
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://privacy.qq.com/policy/tencent-privacypolicy"
          target="_blank"
          data-mce-href="https://privacy.qq.com/policy/tencent-privacypolicy"
          >https://privacy.qq.com/policy/tencent-privacypolicy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        Product/Type:&nbsp;&nbsp;&nbsp;&nbsp; JD Group’s Kepler
      </p>
      <p class="ql-line">
        Application Purpose: Integrating high-quality e-commerce and financial
        services into solution output to be shared with developers through
        strong technical support
      </p>
      <p class="ql-line">Application Scenario:</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: JD</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.airbnb.com/help/article/2855/privacy-policy"
          target="_blank"
          data-mce-href="https://www.airbnb.com/help/article/2855/privacy-policy"
          >https://www.airbnb.com/help/article/2855/privacy-policy</a
        >
      </p>
      <p class="ql-line">Product/Type:&nbsp;&nbsp;&nbsp;&nbsp; Lottie</p>
      <p class="ql-line">Application Purpose: Animation loading tool</p>
      <p class="ql-line">Application Scenario:&nbsp; Animation loading</p>
      <p class="ql-line">Name of Shared Information:&nbsp;&nbsp; NA</p>
      <p class="ql-line">Sharing Method:&nbsp; NA</p>
      <p class="ql-line">Name of Third-Party Company: Airbnb, Inc</p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://www.airbnb.com/help/article/2855/privacy-policy"
          target="_blank"
          data-mce-href="https://www.airbnb.com/help/article/2855/privacy-policy"
          >https://www.airbnb.com/help/article/2855/privacy-policy</a
        >
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p align="left">
        <strong>Checklist of IOS Third-Party SDKs</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>Product/Type:&nbsp;&nbsp; </strong>libWeChatSDK
      </p>
      <p class="ql-line">Application Purpose: Sharing to WeChat, etc.</p>
      <p class="ql-line">
        Application Scenario:&nbsp; Sharing by posters and live streaming
      </p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; Information related to
        infrastructure and app
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDKs</p>
      <p class="ql-line">
        Personal Information Fields Collected: &nbsp; Information related to
        infrastructure and app
      </p>
      <p class="ql-line">
        Name of Third-Party Company: Shenzhen Tencent Computer Systems Company
        Limited
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
          target="_blank"
          data-mce-href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
          >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a
        ><a
          href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ"
          target="_blank"
          data-mce-href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ"
          >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ</a
        >
      </p>
      <p align="left">&nbsp;</p>
      <p class="ql-line"><strong>Product/Type:&nbsp;&nbsp; </strong>Bugly</p>
      <p class="ql-line">
        Application Purpose: Collecting statistics on application running errors
      </p>
      <p class="ql-line">
        Application Scenario:&nbsp; Collecting statistics on application running
        errors
      </p>
      <p class="ql-line">
        Name of Shared Information:&nbsp;&nbsp; Device model, operating system
        version, UDI, signal strength, location information, IP address,
        geographic location information, storage
      </p>
      <p class="ql-line">Sharing Method:&nbsp; Acquired locally by SDKs</p>
      <p class="ql-line">Personal Information Fields Collected:&nbsp;</p>
      <p class="ql-line">
        Name of Third-Party Company: Shenzhen Tencent Computer Systems Company
        Limited
      </p>
      <p class="ql-line">
        Privacy Policy: &nbsp;&nbsp;
        <a
          href="https://privacy.qq.com/"
          target="_blank"
          data-mce-href="https://privacy.qq.com/"
          >https://privacy.qq.com/</a
        >
      </p>
      <p align="left">&nbsp;</p>
      <p class="ql-line"></p>
      <p></p>
    </template>
    <template v-else>
      <h2 align="center">个人信息共享清单</h2>
      <p><strong>一、第三方SDK列表</strong></p>
      <p>
        为保障服贸会相关使用目的的实现和应用的安全稳定运行，我们会接入由第三方提供的软件开发包（SDK）实现该目的。
      </p>
      <p>
        我们会对第三方SDK进行严格的安全检测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务使用目的变更时，我们可能会调整我们接入的第三方SDK，并及时在本说明中向您公开说明接入第三方SDK的最新情况。请注意，第三方SDK可能因为版本升级、策略调整等原因导致数据类型存在一些变化，附其官方网站链接或相关隐私保护说明链接供参考，具体请以其公示的官方说明为准。
      </p>
      <p>&nbsp;</p>
      <p><strong>安卓操作系统第三方SDK列表</strong></p>
      <p class="ql-line"><strong>产品/类型</strong>：微信开放平台</p>
      <p class="ql-line">使用目的：用于微信分享</p>
      <p class="ql-line">使用场景：用于微信授权登录，微信分享</p>
      <p class="ql-line">共享信息名称：基础设备信息，app信息</p>
      <p class="ql-line">共享方式：sdk本机采集</p>
      <p class="ql-line">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
          target="_blank"
          data-mce-href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
          >https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：科大讯飞、讯飞平台</strong></p>
      <p class="ql-line">使用目的：中英文字翻译</p>
      <p class="ql-line">使用场景：中英文互译</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：科大讯飞股份有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="http://zzzx.jyyun.com/pass/pass/userAgreement"
          target="_blank"
          data-mce-href="http://zzzx.jyyun.com/pass/pass/userAgreement"
          >http://zzzx.jyyun.com/pass/pass/userAgreement</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：鹰眼</strong><strong></strong></p>
      <p class="ql-line">使用目的：用于崩溃监控及崩溃模块定位</p>
      <p class="ql-line">使用场景：APP使用过程中的崩溃监控及定位</p>
      <p class="ql-line">
        共享信息名称：Crash
        环境，Crash信息及线程堆栈，ROM/RAM/SD卡容量、网络等状态
      </p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：京东商城技术中心</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="http://docs.avatar.jd.com/crash/sdk/android/version.html?h=%E9%9A%90%E7%A7%81"
          target="_blank"
          data-mce-href="http://docs.avatar.jd.com/crash/sdk/android/version.html?h=%E9%9A%90%E7%A7%81"
          >http://docs.avatar.jd.com/crash/sdk/android/version.html?h=%E9%9A%90%E7%A7%81</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：photoview</strong></p>
      <p class="ql-line">使用目的：图片缩放和拖拽</p>
      <p class="ql-line">使用场景：展商直播上传图片</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Google Inc</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">产品/类型：Reactive Streams</p>
      <p class="ql-line">使用目的：异步数据处理工具</p>
      <p class="ql-line">使用场景：处理异步数据</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">
        第三方公司名称：<a
          href="http://www.reactive-streams.org/"
          target="_blank"
          data-mce-href="http://www.reactive-streams.org/"
          >r</a
        ><a
          href="http://eactive-streams.org"
          data-mce-href="http://eactive-streams.org"
          >eactive-streams.org</a
        >
      </p>
      <p class="ql-line">
        隐私保护说明：<a
          href="http://www.reactive-streams.org/"
          target="_blank"
          data-mce-href="http://www.reactive-streams.org/"
          >http://www.reactive-streams.org/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产</strong>品/类型：rxpermissions</p>
      <p class="ql-line">使用目的：运行时权限申请工具</p>
      <p class="ql-line">使用场景：设备权限开启</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：个人（Thomas Bruyelle）</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://github.com/tbruyelle/RxPermissions#license"
          target="_blank"
          data-mce-href="https://github.com/tbruyelle/RxPermissions#license"
          >https://github.com/tbruyelle/RxPermissions#license</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>产品/类型：eventbus</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>使用目的：事件注册和订阅工具</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>使用场景：应用内部传消息</strong><strong></strong>
      </p>
      <p class="ql-line"><strong>共享信息名称：无</strong><strong></strong></p>
      <p class="ql-line"><strong>共享方式：无</strong><strong></strong></p>
      <p class="ql-line">
        <strong>第三方公司名称：个人（Markus Junginger）</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://greenrobot.org/"
          target="_blank"
          data-mce-href="https://greenrobot.org/"
          >https://greenrobot.org/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：player</strong><strong></strong></p>
      <p class="ql-line">
        <strong>使用目的：视频播放工具</strong><strong></strong>
      </p>
      <p class="ql-line"><strong>使用场景：直播</strong><strong></strong></p>
      <p class="ql-line"><strong>共享信息名称：无</strong><strong></strong></p>
      <p class="ql-line"><strong>共享方式：无</strong><strong></strong></p>
      <p class="ql-line">
        <strong>第三方公司名称：上海宽娱数码科技有限公司（bilibili）</strong
        ><strong></strong>
      </p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://www.bilibili.com/blackboard/privacy-pc.html"
          target="_blank"
          data-mce-href="https://www.bilibili.com/blackboard/privacy-pc.html"
          >https://www.bilibili.com/blackboard/privacy-pc.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">产品/类型：subscaleview</p>
      <p class="ql-line">
        <strong>使用目的：图片缩放工具</strong><strong></strong>
      </p>
      <p class="ql-line">
        <strong>使用场景：直播上传图片</strong><strong></strong>
      </p>
      <p class="ql-line"><strong>共享信息名称：无</strong><strong></strong></p>
      <p class="ql-line"><strong>共享方式：无</strong><strong></strong></p>
      <p class="ql-line">
        <strong>第三方公司名称：个人（davemorrissey）</strong><strong></strong>
      </p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://github.com/davemorrissey/subsampling-scale-image-view"
          target="_blank"
          data-mce-href="https://github.com/davemorrissey/subsampling-scale-image-view"
          >https://github.com/davemorrissey/subsampling-scale-image-view</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">产品/类型：pageindicatorview</p>
      <p class="ql-line">使用目的：翻页指示器</p>
      <p class="ql-line">使用场景：翻页</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：个人（Raman Danylyk）</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://github.com/romandanylyk/PageIndicatorView"
          target="_blank"
          data-mce-href="https://github.com/romandanylyk/PageIndicatorView"
          >https://github.com/romandanylyk/PageIndicatorView</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>腾讯TBS浏览服务</p>
      <p class="ql-line">使用目的：提升H5浏览器体验</p>
      <p class="ql-line">使用场景：用于用户浏览H5页面时</p>
      <p class="ql-line">
        共享信息名称：WIFI信息、MAC地址个人信息，IMSI、bssid、IMEI、设备序列号、android_id
      </p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://x5.tencent.com/tbs/policy.html"
          target="_blank"
          data-mce-href="https://x5.tencent.com/tbs/policy.html"
          >https://x5.tencent.com/tbs/policy.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>SmartRefreshLayout</p>
      <p class="ql-line">使用目的：下拉刷新组件</p>
      <p class="ql-line">使用场景：下拉刷新</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：个人（kimonic）</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://github.com/kimonic/SmartRefreshLayout-master/blob/master/README_CN.md"
          target="_blank"
          data-mce-href="https://github.com/kimonic/SmartRefreshLayout-master/blob/master/README_CN.md"
          >https://github.com/kimonic/SmartRefreshLayout-master/blob/master/README_CN.md</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>gson</p>
      <p class="ql-line">使用目的：json解析工具</p>
      <p class="ql-line">使用场景：gson解析</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Google Inc</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>fastjson</p>
      <p class="ql-line">使用目的：json解析工具</p>
      <p class="ql-line">使用场景：json解析</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：阿里巴巴集团</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://www.alibabagroup.com/cn/global/privacy"
          target="_blank"
          data-mce-href="https://www.alibabagroup.com/cn/global/privacy"
          >https://www.alibabagroup.com/cn/global/privacy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>ARouter</p>
      <p class="ql-line">使用目的：路由跳转工具</p>
      <p class="ql-line">使用场景：路由跳转</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：阿里巴巴集团</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://www.alibabagroup.com/cn/global/privacy"
          target="_blank"
          data-mce-href="https://www.alibabagroup.com/cn/global/privacy"
          >https://www.alibabagroup.com/cn/global/privacy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>glide</p>
      <p class="ql-line">使用目的：图片加载工具</p>
      <p class="ql-line">使用场景：加载图片</p>
      <p class="ql-line">
        共享信息名称：APP版本、应用软件包名、设备型号、判断网络类型
      </p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：开源库-BSD, part MIT and Apache 2.0</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://github.com/bumptech/glide"
          target="_blank"
          data-mce-href="https://github.com/bumptech/glide"
          >https://github.com/bumptech/glide</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>产品/类型：</strong
        >华为推送SDK（华为推送服务，含华为数据分析、华为应用升级、华为广告等服务）
      </p>
      <p class="ql-line">使用目的：用于消息推送</p>
      <p class="ql-line">使用场景：向用户推送消息时</p>
      <p class="ql-line">共享信息名称：系统版本、手机型号</p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：华为技术有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://consumer.huawei.com/cn/privacy/privacy-policy/"
          target="_blank"
          data-mce-href="https://consumer.huawei.com/cn/privacy/privacy-policy/"
          >https://consumer.huawei.com/cn/privacy/privacy-policy/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>OPPO</p>
      <p class="ql-line">使用目的：消息推送</p>
      <p class="ql-line">使用场景：向用户推送消息</p>
      <p class="ql-line">
        共享信息名称：IMEI号，Serial Number，IMSI，User ID，Android ID，Google
        Advertising ID,
        手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果，通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知
      </p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：OPPO</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://open.oppomobile.com/wiki/doc#id=10288"
          target="_blank"
          data-mce-href="https://open.oppomobile.com/wiki/doc#id=10288"
          >https://open.oppomobile.com/wiki/doc#id=10288</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>魅族</p>
      <p class="ql-line">使用目的：消息推送</p>
      <p class="ql-line">使用场景：向用户推送消息</p>
      <p class="ql-line">共享信息名称：匿名用户ID（OAID）</p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：魅族科技有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://www.meizu.com/en/legal.html"
          target="_blank"
          data-mce-href="https://www.meizu.com/en/legal.html"
          >https://www.meizu.com/en/legal.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>小米推送</p>
      <p class="ql-line">使用目的：MIUI推送服务</p>
      <p class="ql-line">使用场景：向用户推送消息</p>
      <p class="ql-line">
        共享信息名称：登录账号、Space
        ID（若使用分身空间功能）、设备相关信息（IMEI号、设备型号、手机操作系统等）、应用信息（APP版本号等）、网络相关信息（IP或域名连接结果，当前网络类型）、系统语言信息、消息发送结果信息等
      </p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：小米科技有限责任公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://dev.mi.com/console/doc/detail?pId=1339"
          target="_blank"
          data-mce-href="https://dev.mi.com/console/doc/detail?pId=1339"
          >https://dev.mi.com/console/doc/detail?pId=1339</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">
        <strong>产品/类型：</strong>VIVO推送SDK（vivo消息推送）
      </p>
      <p class="ql-line">使用目的：用于消息推送</p>
      <p class="ql-line">使用场景：向用户推送消息时</p>
      <p class="ql-line">共享信息名称：品牌型号</p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：广东天宸网络科技有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://dev.vivo.com.cn/documentCenter/doc/180"
          target="_blank"
          data-mce-href="https://dev.vivo.com.cn/documentCenter/doc/180"
          >https://dev.vivo.com.cn/documentCenter/doc/180</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>okhttp</p>
      <p class="ql-line">使用目的：用于应用联网（开源框架）</p>
      <p class="ql-line">使用场景：应用获取网络信息时</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：美国Square移动支付公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://github.com/square/okhttp"
          target="_blank"
          data-mce-href="https://github.com/square/okhttp"
          >https://github.com/square/okhttp</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>okio</p>
      <p class="ql-line">使用目的：网络访问工具</p>
      <p class="ql-line">使用场景：网络访问</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Square, Inc</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://squareup.com/us/en/legal/general/privacy"
          target="_blank"
          data-mce-href="https://squareup.com/us/en/legal/general/privacy"
          >https://squareup.com/us/en/legal/general/privacy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>zxing</p>
      <p class="ql-line">使用目的：网络访问工具</p>
      <p class="ql-line">使用场景：网络访问</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Google, Inc</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>pinyin4j</p>
      <p class="ql-line">使用目的：文字转拼音工具</p>
      <p class="ql-line">使用场景：文字转拼音</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Google Inc</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>语音识别</p>
      <p class="ql-line">使用目的：识别语音，语音合成，语音转文字</p>
      <p class="ql-line">使用场景：洽谈、直播</p>
      <p class="ql-line">
        共享信息名称：摄像头（相机）、相册（图片库）、麦克风（语音）
      </p>
      <p class="ql-line">共享方式：sdk本机采集</p>
      <p class="ql-line">
        收集个人信息字段：摄像头（相机）、相册（图片库）、麦克风（语音）
      </p>
      <p class="ql-line">第三方公司名称：科大讯飞股份有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://www.xfyun.cn/doc/policy/privacy.html"
          target="_blank"
          data-mce-href="https://www.xfyun.cn/doc/policy/privacy.html"
          >https://www.xfyun.cn/doc/policy/privacy.html</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>butterknife</p>
      <p class="ql-line">使用目的：框架</p>
      <p class="ql-line">
        使用场景：开发时用于页面对View的绑定和处理Click事件功能
      </p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：个人（Jack Wharton）</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://jakewharton.github.io/butterknife/"
          target="_blank"
          data-mce-href="https://jakewharton.github.io/butterknife/"
          >https://jakewharton.github.io/butterknife/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>webrtc</p>
      <p class="ql-line">使用目的：框架</p>
      <p class="ql-line">使用场景：在线语音会议时</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Google Inc</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://policies.google.cn/"
          target="_blank"
          data-mce-href="https://policies.google.cn/"
          >https://policies.google.cn/</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>mmkv</p>
      <p class="ql-line">使用目的：存储框架</p>
      <p class="ql-line">使用场景：本地安全存储用户偏好设置时</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://privacy.qq.com/policy/tencent-privacypolicy"
          target="_blank"
          data-mce-href="https://privacy.qq.com/policy/tencent-privacypolicy"
          >https://privacy.qq.com/policy/tencent-privacypolicy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">产品/类型：京东开普勒</p>
      <p class="ql-line">
        使用目的：用于提升浏览体验（Kepler）
      </p>
      <p class="ql-line">使用场景：浏览会议信息时</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：京东</p>
      <p class="ql-line">
        隐私保护说明:&nbsp;<a
          href="https://www.airbnb.com/help/article/2855/privacy-policy"
          target="_blank"
          data-mce-href="https://www.airbnb.com/help/article/2855/privacy-policy"
          >https://www.airbnb.com/help/article/2855/privacy-policy</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">产品/类型：Bugly异常上报</p>
      <p class="ql-line">
        使用目的：用于分析和统计系统错误
      </p>
      <p class="ql-line">使用场景：应用崩溃信息上报时</p>
      <p class="ql-line">
        共享信息名称：设备唯一标识码、App包名和版本及所属进程名、Crash信息及线程堆栈、ROM/RAM/SD卡容量、网络/语言状态
      </p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p class="ql-line">
        隐私保护说明:&nbsp;<a
          href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf"
          target="_blank"
          data-mce-href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf"
          >https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf</a
        >
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">产品/类型：Lottie</p>
      <p class="ql-line">使用目的: 动画加载</p>
      <p class="ql-line">使用场景：加载动画</p>
      <p class="ql-line">共享信息名称：无</p>
      <p class="ql-line">共享方式：无</p>
      <p class="ql-line">第三方公司名称：Airbnb, Inc</p>
      <p class="ql-line">
        隐私保护说明:&nbsp;<a
          href="https://www.airbnb.com/help/article/2855/privacy-policy"
          target="_blank"
          data-mce-href="https://www.airbnb.com/help/article/2855/privacy-policy"
          >https://www.airbnb.com/help/article/2855/privacy-policy</a
        >
      </p>
      <p>&nbsp;</p>
      <p class="ql-line">
        产品/类型：核验SDK（人脸识别，生物探针，身份证验证等）
      </p>
      <p class="ql-line">使用目的: 用户核验身份</p>
      <p class="ql-line">使用场景：洽谈</p>
      <p class="ql-line">共享信息名称：身份证，姓名</p>
      <p class="ql-line">共享方式：SDK本机采集</p>
      <p class="ql-line">第三方公司名称：京东</p>
      <p class="ql-line">
        隐私保护说明:&nbsp;<a
          href="https://about.jd.com/privacy/"
          target="_blank"
          data-mce-href="https://about.jd.com/privacy/"
          >https://about.jd.com/privacy/</a
        >
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p align="left">
        <strong>IOS</strong><strong>操作系统第三方SDK列表</strong>
      </p>
      <p class="ql-line"><strong>产品/类型：</strong>libWeChatSDK</p>
      <p class="ql-line">使用目的:分享到微信等</p>
      <p class="ql-line">使用场景：海报分享、直播分享</p>
      <p class="ql-line">共享信息名称：基础设备信息，app信息</p>
      <p class="ql-line">共享方式：sdk本机采集</p>
      <p class="ql-line">收集个人信息字段：基础设备信息，app信息</p>
      <p class="ql-line">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p class="ql-line">
        隐私说明：<a
          href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
          target="_blank"
          data-mce-href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
          >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a
        ><a
          href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ"
          target="_blank"
          data-mce-href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ"
          >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/ONwPihxKd82RAkIJ</a
        >
      </p>
      <p align="left">&nbsp;</p>
      <p class="ql-line"><strong>产品/类型：</strong>Bugly</p>
      <p class="ql-line">使用目的:用于统计应用运行异常错误数据</p>
      <p class="ql-line">使用场景：统计运行时异常</p>
      <p class="ql-line">
        共享信息名称：设备型号、操作系统版本、唯一设备标识符、信号强度、位置信息、IP地址、地理位置信息、存储
      </p>
      <p class="ql-line">共享方式：sdk本机采集</p>
      <p class="ql-line">收集个人信息字段：</p>
      <p class="ql-line">第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p class="ql-line">
        隐私保护说明：<a
          href="https://privacy.qq.com/"
          target="_blank"
          data-mce-href="https://privacy.qq.com/"
          >https://privacy.qq.com/</a
        >
      </p>
    </template>
  </div>
</template>

<script>
import { getPolicyDetailById } from '@/api/newscenter-api'
import { getLang } from '@/utils'

export default {
  data() {
    return {
      locale: this.$route.query.lang == 'en' ? 'en-US' : '',
      lang: 'zh-CN',
      remoteContent: '',
      isLoading: true
    }
  },
  created() {
    const detectedLang = this.locale ? this.locale : getLang()
    if (detectedLang) {
      this.lang = detectedLang
    }
    this.loadContent()
  },
  methods: {
    async loadContent() {
      const {
        VUE_APP_PERSONAL_INFO_SHARING_ID = '',
        VUE_APP_PERSONAL_INFO_SHARING_EN_ID = ''
      } = process.env

      const targetId =
        this.lang === 'en-US'
          ? VUE_APP_PERSONAL_INFO_SHARING_EN_ID ||
            VUE_APP_PERSONAL_INFO_SHARING_ID
          : VUE_APP_PERSONAL_INFO_SHARING_ID

      if (!targetId) {
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        const response = await getPolicyDetailById(targetId, this.lang)
        const richText = this.extractRichText(response)
        if (richText && richText.trim().length > 0) {
          this.remoteContent = richText
        }
      } catch (error) {
        // Fallback to bundled content on failure.
      } finally {
        this.isLoading = false
      }
    },
    extractRichText(response) {
      const result = response && response.result
      if (!result) {
        return ''
      }

      const container = result.content || result.data
      if (container && container.richText) {
        return container.richText.replace(
          /text-wrap-mode:\s*nowrap/g,
          'text-wrap-mode: wrap'
        )
      }

      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep table {
  border-collapse: collapse;
}
.rule-text-box {
  max-width: 1200px;
  width: 100%;
  margin: 20px auto;
  padding: 30px;
  background: #fff;
  font-size: 14px;
  line-height: 28px;
  overflow-x: auto;
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-overflow-scrolling: touch;
  h2 {
    margin: 0 0 32px;
    padding: 0 0 20px;
    border-bottom: 1px solid #eee;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  hr {
    margin: 20px 0;
  }
  a {
    color: #0175d4;
    text-decoration: underline;
  }
  table {
    width: 100%;
    margin: 12px 0;
    border-collapse: collapse;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  th,
  td {
    padding: 6px 4px;
    border: 1px solid #ccc;
    background: #fff;
    white-space: normal;
    word-break: break-word;
  }
  th {
    background: #f5f5f5;
  }
  img {
    max-width: 100%;
    height: auto;
  }
}
@media screen and (max-width: 800px) {
  .rule-text-box {
    width: 100%;
    margin: 0;
    padding: 15px;
    line-height: 28px;
    h2 {
      margin: 6px 0 10px;
      padding: 0;
      border-bottom: none;
      font-size: 20px;
      line-height: 36px;
    }
  }
}
</style>
